<template>
    <div>
        <ul class="nav-box">
            <li class="nav" v-for='(item,index) in navArr' :key='index' :class='{active:item.id==navName}' @click="navTo(item.id)">
                <div><img class="icon" :class="{active: item.id == 'index'}" :src="item.cur_img" alt="nav" v-show='item.id!=navName'><img class="icon" :class="{active: item.id == 'index'}" :src="item.active_img" alt="nav" v-show='item.id==navName'></div>
                <div class="text">{{item.navName}}</div>
            </li>
        </ul>
    </div>
</template>
<script>
    export default {
        name: 'navBar',
        props:['navName'],
        data () {
            return {
                navArr: [
                    {
                        'id':'index',
                        'navName': this.$t('footer.home'),
                        'cur_img': require('@/assets/nav/icon-bz1.png'),
                        'active_img':require('@/assets/nav/icon-bz2.png')
                    },
                    {
                        'id':'quotes',
                        'navName': this.$t('footer.quotation'),
                        'cur_img': require('@/assets/nav/icon-hq1.png'),
                        'active_img':require('@/assets/nav/icon-hq2.png')
                    },
                    {
                        'id':'preciousMetal',
                        'navName': this.$t('langNew.jy'),
                        'cur_img': require('@/assets/nav/icon-bbjy1.png'),
                        'active_img':require('@/assets/nav/icon-bbjy2.png')
                    },
                    {
                        'id':'contractTransaction',
                        'navName': this.$t('langNew.szhb'),
                        'cur_img': require('@/assets/nav/icon-hyjy1.png'),
                        'active_img':require('@/assets/nav/icon-hyjy2.png')
                    },
                    {
                        'id':'myAssets',
                        'navName': this.$t('footer.assets'),
                        'cur_img': require('@/assets/nav/icon-user1.png'),
                        'active_img':require('@/assets/nav/icon-user2.png')
                    },
                ]
            }
        } ,
        mounted(){

        },
        methods: {
            navTo(nav){
                this.$router.push('/'+nav);
            }
        },
    }
</script>
<style scoped>
    .nav-box{
        position: fixed;
        left: 0;
        bottom: 0;
        z-index: 100;
        display: flex;
        width: 100%;
        justify-content: space-around;
        align-items: center;
        height: 2.1rem;
        background: #fff;
        box-sizing: border-box;
    }
    .nav-box .nav{
        width: 20%;
        color: #c5cad4;
        font-size: .34rem;
        text-align: center;
    }
    .nav-box .nav.active{
        color: #000;
    }
    .nav-box .nav .icon{
        width: .62rem;
        height: .62rem;
    }
    .nav-box .nav .icon.active{
        width: .62rem;
        height: .62rem;
    }
    /* .nav-box .nav:first-child .icon{
      width: 1.2rem;
      height: auto;
    }
    .nav-box .nav:first-child .icon.active{
      width: 1.4rem;
      height: auto;
    } */
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue